import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fourWheelDrive"
const FourWheelDriveIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.756 8.538h.744c.771 0 1.292-.54 1.292-1.33V3.386c0-.8-.52-1.339-1.293-1.339h-.743c-.763 0-1.284.54-1.284 1.34v1.197H7.546V3.386c0-.8-.521-1.339-1.293-1.339h-.744c-.762 0-1.283.54-1.283 1.34v3.82c0 .791.52 1.33 1.283 1.33h.744c.772 0 1.293-.539 1.293-1.33V6.082h3.71v11.977h-3.71v-1.163c0-.8-.521-1.339-1.293-1.339h-.744c-.762 0-1.283.54-1.283 1.34v3.821c0 .79.52 1.33 1.283 1.33h.744c.772 0 1.293-.54 1.293-1.33v-1.162h8.926v1.162c0 .79.521 1.33 1.284 1.33h.744c.771 0 1.292-.54 1.292-1.33v-3.822c0-.8-.52-1.339-1.292-1.339h-.744c-.763 0-1.284.54-1.284 1.34v1.162h-3.72V6.08h3.72v1.127c0 .79.521 1.33 1.284 1.33Z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FourWheelDriveIcon
